<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-09-08 17:52:14
 * @FilePath: 
 * @Description:商品详情中图文简介组件
-->
<template>
  <div class="induction_con">
    <p class="c-main-txt font-36 c-m-b-20 c-t-c">商品详情</p>
    <!-- <div v-html="textInduction"></div> -->
    <div class="ql-container ql-snow">
      <div class="ql-editor" v-html="textInduction" />
    </div>
  </div>
</template>

<script>
export default {
  name: "GoodsImgCom",
  props: {
    textInduction: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  components: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="scss">
.induction_con {
  padding: 30px 30px 130px;
  background: #fff;

  ::v-deep img {
    width: 100%;
    vertical-align: middle;
  }
}
</style>
